// extracted by mini-css-extract-plugin
export default {"stepper":"Stepper_stepper__iJnYT"};